// CANONICAL COPY (GH #7115). src/constants/obligations/obl-privileged-access-management.js re-exports this file so the browser and the
// Function App share one compliance engine — one definition of "compliant". Edit here, never there.
'use strict';

module.exports = {
  id: 'obl-privileged-access-management',
  title: 'Review privileged access rights',
  description:
    'Confirm that the allocation and use of privileged access rights is restricted, granted only on a need-to-use basis, and monitored. Review the list of privileged accounts and service accounts, verify approvals and revocation on role change, and inspect activity logs for privileged operations. Where Entra ID is connected, every privileged admin account must have MFA enabled — auto-verified from the synced identity posture.',
  category: 'access',
  scfIds: ['SCF-IAM-005'],
  cadence: { frequency: '3m', anchor: 'domain' },
  // SDEA-04: KNOWN VACUOUS-PASS GAP (same class as SDEA-03 / PR #6121).
  // 'privileged-mfa-enrolled' returns pass:true whenever a tenant has zero
  // Entra-synced privileged accounts — including a tenant with no Entra
  // connection at all. Under 'any', a tenant that has adopted neither a
  // published/current privileged-access policy NOR Entra MFA tracking still
  // passes this obligation solely on that vacuous pass. Tracked as a known
  // gap for a later fix pass, not blocking this flip.
  strategy: 'any',
  fulfilmentCriteria: [
    { type: 'document-published', description: 'Privileged access policy is published' },
    { type: 'document-within-sla', description: 'Privileged access policy review is not overdue' },
    // Entra-sourced: vacuous-pass when no privileged Entra accounts exist.
    {
      type: 'privileged-mfa-enrolled',
      description:
        'Every privileged Entra admin has MFA enabled (vacuous-pass if no Entra connection or no privileged accounts)',
    },
  ],
  domainActions: [{ type: 'approve-document', label: 'Approve Document' }],
};
